import { render, staticRenderFns } from "./CadastroImpostos.vue?vue&type=template&id=760a4fdc&"
import script from "./CadastroImpostos.vue?vue&type=script&lang=js&"
export * from "./CadastroImpostos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports